const initState = () => Object.assign({}, {
  scheduler: {
    emails: '',
    cronExpressionHour: 0,
    cronExpressionMinute: 0,
    timeZoneId: 'America/Los_Angeles',
  },
  isScheduleProcessing: false,
  isLoaded: false,
  scheduleToast: {}
});

export const schedulerReducer = (state = initState(), action) => {
  switch (action.type) {
  case 'RESET_SCHEDULER_STATE':
    return {
      ...state,
      scheduler: initState().scheduler,
      scheduleToast: { type: 'SUCCESS' },
      isScheduleProcessing: false
    };
  case 'PROCESSING':
    return {
      ...state,
      scheduleToast: { type: 'LOADING' },
      isScheduleProcessing: true,
      isLoaded: false,
    };
  case 'FETCH_SCHEDULER':
    return {
      ...state,
      scheduler: action.payload,
      scheduleToast: { type: 'SUCCESS' },
      isScheduleProcessing: false
    };
  case 'UPSERT_SCHEDULER':
    return {
      ...state,
      scheduler: action.payload,
      scheduleToast: { type: 'SUCCESS' },
      isScheduleProcessing: false
    };
  case 'SCHEDULER_ERROR':
    return {
      ...state,
      isProcessing: false,
      scheduleToast: { type: 'ERROR', message: action.payload },
    };
  default:
    return state;
  }
};